import { ResetPasswordTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ResetPasswordTrackingSchema: Record<
  ResetPasswordTrackingPoint,
  string
> = {
  [ResetPasswordTrackingPoint.PageView]: '41ac3532-1807-4f40-84e4-67cdedabc71c',
  [ResetPasswordTrackingPoint.NextButtonClick]:
    'ec8041c1-52f9-4333-aacf-6a732937fa2a',
  [ResetPasswordTrackingPoint.HelpButtonClick]:
    'b8e7912c-0709-41f7-84c4-f89d0a1aeb1f',
  [ResetPasswordTrackingPoint.BackButtonClick]:
    '3a921510-eb54-4cae-a363-e5237ef148f1',
  [ResetPasswordTrackingPoint.ContactUsButtonClick]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupImpression]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupOkButtonClick]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupCancelButtonClick]: '',
  [ResetPasswordTrackingPoint.CaptchaPopupRefreshButtonClick]: '',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeView]:
    'fa6eb64c-a179-413a-806d-f1b2aaa35f5a',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeOkClick]:
    'bdac7486-84be-4ff0-bb53-af0eb342784e',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeContactUsClick]:
    '3860feb2-74fd-4f19-bc7e-ea37564ff7a8',
  [ResetPasswordTrackingPoint.ResetPasswordOnShopeeCancelClick]: '',
  [ResetPasswordTrackingPoint.ResetPasswordSuccessAction]:
    '0c7245f0-448b-4187-8c73-f167ed361818',
  [ResetPasswordTrackingPoint.ResetPasswordFailAction]:
    'b887c817-0eb2-41b5-a381-9a93e0c8391a',
};

export const getResetPasswordPageTypeAndSchema = (
  trackingPoint: ResetPasswordTrackingPoint
) => {
  return {
    page_type: PageType.ResetPasswordPage,
    schema: ResetPasswordTrackingSchema[trackingPoint],
  };
};
